import { render, staticRenderFns } from "./OnboardingEstimationPage.vue?vue&type=template&id=f43344f8&scoped=true&"
import script from "./OnboardingEstimationPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingEstimationPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingEstimationPage.vue?vue&type=style&index=0&id=f43344f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43344f8",
  null
  
)

export default component.exports